import VendorInfoModal from './VendorInfoModal'
import TagInfoModal from './TagInfoModal'

export default {
  VendorInfoModal,
  TagInfoModal
}
